import { css } from '@emotion/react';
import {
  useCallback, useEffect, useState,
} from 'react';
import { TextareaScrollableComponent } from '~/_shared/baseComponents/textareaScrollable/textareaScrollable.component';
import { AddMorePlaceholderComponent } from '~/_shared/components/addMorePlaceholder/addMorePlaceholder.component';
import { FormErrorMessageComponent } from '~/_shared/components/formErrorMessage/formErrorMessage.component';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { useHookWithRefCallback } from '~/_shared/utils/hooks/useHookWithRefCallback';

const containerStyle = css({
  position: 'relative',
});

export type TextInputSpreadsheetDataProps = Readonly<{
  errorMessage?: string;
  isLoading?: boolean;
  value: string;
  onInputChange: (text: string) => void;
}>;

export const TextInputSpreadsheetDataComponent = ({
  errorMessage,
  isLoading,
  value,
  onInputChange,
}: TextInputSpreadsheetDataProps) => {
  const [t] = useTranslation();

  const [showTextarea, setShowTextarea] = useState(false);
  const [descriptionRef, setDescriptionRef] = useHookWithRefCallback<HTMLTextAreaElement>();
  const [focusDescription, setFocusDescription] = useState(false);

  const handleTriggerClick = useCallback(() => {
    setShowTextarea(true);
    setFocusDescription(true);
  }, []);

  useEffect(() => {
    if (!descriptionRef || !showTextarea || !focusDescription) {
      return;
    }

    descriptionRef.focus();
    setFocusDescription(false);
  }, [descriptionRef, focusDescription, showTextarea]);

  return (
    <div css={containerStyle}>
      {isLoading && (<OverlayLoaderComponent />)}
      {!showTextarea && (
        <AddMorePlaceholderComponent
          onClick={handleTriggerClick}
          title={t('Paste Data')}
        />
      )}

      {showTextarea && (
        <>
          <TextareaScrollableComponent
            ref={setDescriptionRef}
            value={value}
            onChange={onInputChange}
            placeholder={SAMPLE_TEXT}
            height={75}
          />

          {errorMessage && (
            <FormErrorMessageComponent
              messages={[errorMessage]}
              isSingleLine={false}
            />
          )}
        </>
      )}
    </div>
  );
};

const SAMPLE_TEXT = `Address\tCity\tState\tZipcode\tName
1 Crossgates Mall Road\tAlbany\tNY\t12203\tStore
Duke Rd  & Walden Ave\tBuffalo\tNY\t14225\tShop
630 Old Country Rd.\tGarden City\tNY\t11530\tMarket`;
